import React from 'react';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import styles from './Confirmation.styles';
import Button from '../../inputs/button/Button';

const Confirmation = props => {
  const confirmText = props.confirmText || I18n.t('confirmation.message');
  return (
    <div className={css(styles.base)}>
      <div className={css(styles.text)}>
        <p className={css(styles.p)}>{confirmText}</p>
        <p className={css(styles.p)}>{props.itemName}</p>
      </div>
      <div className={css(styles.actions)}>
        <Button styles={[styles.btn, styles.confirm]} onClick={props.confirm}>
          {I18n.t('confirmation.confirm')}
        </Button>
        <Button styles={[styles.btn, styles.deny]} onClick={props.deny}>
          {I18n.t('confirmation.reject')}
        </Button>
      </div>
    </div>
  );
};

export default Confirmation;



// WEBPACK FOOTER //
// ./src/components/common/confirmation/Confirmation.js